import { computed, unref } from 'vue';
import type { Composer } from 'vue-i18n';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import {
  asbisUiPlugin,
  definePluginOptions,
} from '@webplatform/asbis-ui/integrations/nuxt';
import { createDataLoaders } from '~/domains/asbis-ui';

export default defineNuxtPlugin({
  name: 'prestigio:asbis-ui',
  dependsOn: ['frontkit:cms-api', 'i18n:plugin'],
  setup(nuxtApp) {
    const { gmapId } = useRuntimeConfig().public.frontkit;
    const { $api, $httpClient, vueApp } = nuxtApp;
    const localePath = useLocalePath();
    const i18n = nuxtApp.$i18n as Composer | undefined;
    const currentLanguage = computed(() => unref(i18n?.locale) ?? 'en');

    const options = definePluginOptions({
      gsap,
      ScrollTrigger,
      theme: 'prestigio',
      currentLanguage,
      productCardLinkPrefix: '/product',
      localePath: (path: string) => localePath(path),
      googleMapsApiKey: gmapId,
      dataFetchFunctions: createDataLoaders($api, $httpClient),
    });

    vueApp.use(asbisUiPlugin, options);
  },
});
